<template>
  <UiCard>
    <div slot="title">
      <div class="title">Данные</div>
    </div>

    <div slot="content">
      <UiFakeInputs />

      <div class="row two-columns between-xs">
        <!-- `fields` находятся в файле './fields.js' -->
        <form-group
          v-for="field in fields"
          :key="field.key"
          :validator="$v.form[field.key]"
          :server-errors="serverError(field.key)"
        >
          <template slot-scope="{ attributes }">
            <UiInputText
              v-model.trim="form[field.key]"
              :class="attributes.class"
              v-bind="field.attrs"
              v-on="field.listeners"
            />
          </template>
        </form-group>
      </div>
    </div>

    <div slot="footer">
      <UiButton
        :disabled="trySaveManager"
        :class="['button', 'is-blue', { 'is-loading': trySaveManager }]"
        @click="updateManager"
      >
        Сохранить
      </UiButton>
    </div>
  </UiCard>
</template>

<script>
import UiCard from '@/components/card/UiCard.vue'
import UiButton from '@/components/UiButton.vue'
import UiInputText from '@/components/UiInputText.vue'
import UiFakeInputs from '@/components/UiFakeInputs.vue'

import fields from './fields.js'

import { ManagersService } from '@/services/managers.service'

import { mapGetters } from 'vuex'

export default {
  components: {
    UiButton,
    UiInputText,
    UiCard,
    UiFakeInputs,
  },
  mixins: [fields],
  data() {
    return {
      trySaveManager: false,

      form: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        position: '',
      },
    }
  },

  computed: {
    ...mapGetters({
      manager: 'managers/manager',
    }),
  },
  watch: {
    /** Set `this.form` data from vuex data */
    manager: {
      handler: function (data) {
        this.form = { ...data }
      },
    },
  },
  methods: {
    /**
     * Send request to backend for update manager info.
     * Before send run validation check $v.$touch()
     *
     * @returns {void}
     * */
    async updateManager() {
      this.$v.$touch()
      this.clearFormServerErrors()

      if (this.$v.$invalid) return

      this.trySaveManager = true
      try {
        const id = this.manager.id
        const payload = { ...this.form }

        await ManagersService.update({ id, payload })

        this.$store.commit('toast/NEW', { type: 'success', message: 'Операция выполнена.' })
      } catch (error) {
        this.formServerErrors = error.formServerErrors

        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      } finally {
        this.trySaveManager = false
      }
    },
  },
}
</script>
